import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconRequest = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.77778 6C8.34788 6 8 6.34823 8 6.77778V16.1111C8 16.5407 8.34788 16.8889 8.77778 16.8889H10.7222V19.2222C10.7222 19.5285 10.9022 19.8063 11.1817 19.9317C11.4605 20.0572 11.7879 20.007 12.0165 19.8036L15.2955 16.8889H21.2222C21.6521 16.8889 22 16.5407 22 16.1111V6.77778C22 6.34823 21.6521 6 21.2222 6H8.77778ZM9.55556 7.55556H20.4445V15.3334H15C14.8094 15.3334 14.6256 15.4033 14.4835 15.5298L12.2778 17.4903V16.1111C12.2778 15.6816 11.9299 15.3334 11.5 15.3334H9.55556V7.55556ZM15.7781 9.11123C15.7781 8.68167 15.4302 8.33345 15.0003 8.33345C14.5704 8.33345 14.2225 8.68167 14.2225 9.11123V11.4446C14.2225 11.8741 14.5704 12.2223 15.0003 12.2223C15.4302 12.2223 15.7781 11.8741 15.7781 11.4446V9.11123ZM15.0003 13C15.4302 13 15.7781 13.3482 15.7781 13.7778C15.7781 14.2073 15.4302 14.5556 15.0003 14.5556C14.5704 14.5556 14.2225 14.2073 14.2225 13.7778C14.2225 13.3482 14.5704 13 15.0003 13ZM1 8.33341C1 7.90386 1.34787 7.55563 1.77778 7.55563H6.44445C6.87436 7.55563 7.22223 7.90386 7.22223 8.33341C7.22223 8.76296 6.87436 9.11119 6.44445 9.11119H1.77778C1.34787 9.11119 1 8.76296 1 8.33341ZM2.5554 11.4443C2.5554 11.0148 2.90328 10.6666 3.33318 10.6666H6.4443C6.8742 10.6666 7.22208 11.0148 7.22208 11.4443C7.22208 11.8739 6.8742 12.2221 6.4443 12.2221H3.33318C2.90328 12.2221 2.5554 11.8739 2.5554 11.4443ZM4.11126 14.5556C4.11126 14.126 4.45914 13.7778 4.88904 13.7778H6.4446C6.8745 13.7778 7.22238 14.126 7.22238 14.5556C7.22238 14.9852 6.8745 15.3334 6.4446 15.3334H4.88904C4.45914 15.3334 4.11126 14.9852 4.11126 14.5556Z"
        />
      </svg>
    );
  }
);
